
;(function ($) {
    'use strict';

    const pluginName = 'prices';

    function Plugin(elements) {
        this._name = pluginName;
        this.elements = $(elements);
        this.templates = {};
        this.numberFormat = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
        });
        this.numberFormatShort = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 0
        });
        this.percentageFormat = new Intl.NumberFormat('de-DE', {
            style: 'unit',
            unit: 'percent',
            maximumFractionDigits: 0
        });

        this.init();
        return this;
    }

    $.extend(Plugin.prototype, {
        init: function () {
            if (this.elements.length === 0) {
                return;
            }

            const that = this;
            function updateElement(element, articleData, priceData) {
                const additionalClass = $(element).data('additional-class') ?? ''
                const priceTmplId = $(element).data('price-tmpl') ?? 'tpl--price--default'
                const priceTmpl = that.getTemplate(priceTmplId);

                if (priceData === null || priceData === undefined) {
                    $(element).html(priceTmpl({showPrice: false, additionalClass: additionalClass}))
                    return;
                }

                const price = priceData;
                let discountPercentage = price.discountPercentage ?? 0
                let discountValue = price.discountValue ?? 0
                let unitDiscountValue = price.unitDiscountValue ?? 0
                let originalUnitPrice = price.originalUnitPrice ?? 0
                let originalAmount = price.originalAmount ?? 0
                const unitPrice = price.unitPrice ?? 0
                const amount = price.amount ?? 0

                const discountPercentageFormatted = that.percentageFormat.format(discountPercentage)
                const discountValueFormatted = that.numberFormat.format(discountValue)
                const discountValueRoundedFormatted = that.numberFormatShort.format(discountValue)
                const unitDiscountValueFormatted = that.numberFormat.format(unitDiscountValue)
                const originalUnitPriceFormatted = that.numberFormat.format(originalUnitPrice)
                const originalAmountFormatted = that.numberFormat.format(originalAmount)
                const unitPriceFormatted = that.numberFormat.format(unitPrice)
                const amountFormatted = that.numberFormat.format(amount)

                let quantityDiscounts = {}
                Object.keys(price.quantityDiscounts).forEach( function (fromQuantity) {
                    quantityDiscounts[fromQuantity] = that.numberFormat.format(price.quantityDiscounts[fromQuantity]);
                });

                $(element).html(priceTmpl({
                    additionalClass: additionalClass,
                    discountPercentage: discountPercentage != 0 ? discountPercentageFormatted : null,
                    discountValue: discountValue != 0 ? discountValueFormatted : null,
                    discountValueRounded: discountValue != 0 ? discountValueRoundedFormatted : null,
                    discountValueIsWhole: discountValue % 1 == 0,
                    discountPercentageIsWhole: discountPercentage % 1 == 0,
                    unitDiscountValue: unitDiscountValue != 0 ? unitDiscountValueFormatted : null,
                    originalUnitPrice: originalUnitPrice != 0 ? originalUnitPriceFormatted : null,
                    originalAmount: originalAmount != 0 ? originalAmountFormatted : null,
                    unitPrice: unitPrice ? unitPriceFormatted : null,
                    amount: amount ? amountFormatted : null,
                    isAction: price.isActionPrice,
                    isDiscountable: price.isDiscountable,
                    showSavingsAsPercentage: articleData.showSavingsAsPercentage,
                    showPrice: true,
                    quantityDiscounts: quantityDiscounts
                }))
            }

            this.elements.each(function () {
                if ($(this).data(pluginName + '_done')) {
                    return;
                }

                $(this).data(pluginName + '_done', true);
                $(this).on('buy-data-loaded', function (e) {
                    const element = this;
                    updateElement(element, e.article, e.price);
                });
            });
        },
        getTemplate(id) {
            if (this.templates[id] === undefined) {
                this.templates[id] = _.template($('#' + id).html());
            }

            return this.templates[id];
        }
    });

    /**
     * Plugin Wrapper
     *
     * @param options
     * @returns {*}
     */
    $.fn[pluginName] = function (options) {
        if (options === undefined || typeof options === 'object') {
            return $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
        }
    };
})(jQuery);
